// Function to handle cart drawer visibility with optional delay
function handleAddToCart(isDelayed = false) {
  // Remove the rebuy-cart-visible class from the body
  document.body.classList.remove("rebuy-cart-visible");

  if (isDelayed) {
    // Delay adding the drawer--visible class by 2 seconds
    setTimeout(() => {
      const cartDrawer = document.querySelector(".cart__drawer");
      if (cartDrawer) {
        cartDrawer.classList.add("drawer--visible");
      }
    }, 2000); // 2000 milliseconds = 2 seconds
  } else {
    // Immediate addition of the drawer--visible class
    const cartDrawer = document.querySelector(".cart__drawer");
    if (cartDrawer) {
      cartDrawer.classList.add("drawer--visible");
    }
  }
}

// Define the custom element class
class ProductBtn extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.btn--add-to-cart');

    if (this.button) {
      this.button.addEventListener('click', this.handleClick.bind(this));
    }
  }

  handleClick(event) {
    event.preventDefault();

    // Check if the button has the 'btn--add-to-cart' class
    const isAddToCartButton = this.button.classList.contains('btn--add-to-cart');

    // Execute handleAddToCart with a delay if the button has the 'btn--add-to-cart' class
    handleAddToCart(isAddToCartButton);
  }
}

// Register the custom element
customElements.define('product-btn', ProductBtn);

// Function to handle cart drawer visibility and navlink click
function handleAddToCart() {
  // Remove the rebuy-cart-visible class from the body
  document.body.classList.remove("rebuy-cart-visible");

  // Add the drawer--visible class to cart__drawer
  const cartDrawer = document.querySelector(".cart__drawer");
  if (cartDrawer) {
    cartDrawer.classList.add("drawer--visible");
  }
}

// Add event listener to both buttons with a delay
document
  .querySelectorAll(".quick-add-product")
  .forEach((button) => {
    button.addEventListener("click", function () {
      setTimeout(handleAddToCart, 2000); // 2-second delay before executing handleAddToCart
    });
  });




